<template>
<div class="publicViewClass" style="padding-top:0">
    <div class="app-inner paperJk">
     <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/testPapeList')">
            返回
            </div>
            </div>
            <div class="tit flex align-cen">
                试卷名称：{{pageInfo.paperName}} | 考试时间：限制{{pageInfo.timeLimit}}分钟
            </div>
        <!-- type切换 -->
        <div class="status-list flex align-cen">
                        <div class="status-list-item " @click="getResultList(1,true)" :class="{'active':isActive == 1}">
                <div class="circle">
                 <div class="message">
                <div class="num">{{pageInfo.examinedNum}}</div>
                <div class="title">已考完</div>
            </div>
                </div>
            </div>
            <div class="status-list-item" @click="getResultList(0,true)" :class="{'active':isActive == 0}">
                <div class="circle">
                    <div class="message">
                        <div class="num">{{pageInfo.examiningNum}}</div>
                        <div class="title">正在考</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tabbable-custom">
             <div class="rdsdiv"></div>
              <div class="businessList-container-table" style="margin-top:16px;margin-bottom:50px">
               <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable'
          :key="123"
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
        >
         <!-- <el-table-column type="selection" width="55" reserve-selection align="center" fixed="left"> </el-table-column> -->
            <el-table-column  label="序号" align="center" width="55">
            <template slot-scope="scope">
              <div >{{scope.$index + 1}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="examiner" label="姓名" align="center">
          </el-table-column>
            <el-table-column prop="businessName" label="所属企业" align="center" width="250">
          </el-table-column>
        <el-table-column  label="答题进度" align="center" v-if="isActive == 0">
           <template slot-scope="scope">
              <div  v-if="isActive == 0">{{scope.row.answerCount}}/{{scope.row.questionCount}}</div>
            </template>
          </el-table-column> 
            <el-table-column prop="userScore" label="得分" align="center" v-if="isActive == 1">
                 <template slot-scope="scope">
                 <div  v-if="isActive == 1">
                    <span  v-if="scope.row.result !=2">{{String(scope.row.userScore)}}</span>
                     <span  v-else>-</span>
                    </div> 
                 </template>
          </el-table-column>
           <el-table-column  label="得分比" align="center" v-if="isActive == 1">
             <template slot-scope="scope">
              <div  v-if="isActive == 1">{{scope.row.scoreRate || '0.00'}}%</div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="考试时间" align="center" v-if="isActive == 1">
             <template slot-scope="scope">
              <div  v-if="isActive == 1">{{scope.row.startTime}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="createBy" label="用时" align="center" v-if="isActive == 1">
             <template slot-scope="scope">
              <div  v-if="isActive == 1">{{convertSecondsToMinutes(scope.row.doTime,1)}}</div>
            </template>
          </el-table-column>
          <el-table-column  label="进入考试时间" align="center" v-if="isActive == 0">
             <template slot-scope="scope">
              <div  v-if="isActive == 0">{{scope.row.startTime}}</div>
            </template>
          </el-table-column>
          <el-table-column  label="IP" align="center" v-if="isActive == 0">
            <template slot-scope="scope">
              <div  v-if="isActive == 0">{{scope.row.ip}}</div>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="200"
            >
              <template slot-scope="scope">
                 <el-button type="text" size="small"  slot="reference" style="color:red" v-if="isActive == 0" @click.stop="subqz(scope.row)">强制交卷</el-button>
                 <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="openTimline(scope.row)" v-if="isActive == 0">监控</el-button>
                <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="getResulttRanscript(scope.row)" v-if="isActive == 1 && scope.row.result !=2">成绩单</el-button>
                <el-button type="text" size="small"  slot="reference" style="color:red"  @click.stop="getResulttRanscript(scope.row)" v-if="isActive == 1 && scope.row.result ==2">查看</el-button>
                 <el-button type="text" size="small"  slot="reference" style="color:red"   @click.stop="getGradingPaper(scope.row)" v-if="isActive == 1 && scope.row.result ==2">批卷</el-button>
            </template>
          </el-table-column>
          
            </el-table>
             <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
             </div>
        </div>
    </div>
    <!-- 查看成绩单 -->
       <!-- 打开自定义分段 -->
      <el-dialog
  title="查看成绩单"
  :visible.sync="centerDialogVisible"
  width="40%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass paperDialogClass"
  v-if="centerDialogVisible && isActive == 1"
  >
    <el-tabs  v-model="activeName">
           <el-tab-pane label="本次成绩" name="1">
            <div class="print-tab-content">
                <div class="tester-info">
                    <p class="text">{{testerInfo.paperName}}</p>
                    <p class="text">考试者：{{testerInfo.examiner}}</p>
                    <p class="lastP">
                        开始时间：{{testerInfo.startTime}} | 交卷时间：{{testerInfo.answerTime}} 
                    </p>
                    <div class="sorceRow">
                        <div class="result-scores">
                            <div class="exam-record-info" v-if="testerInfo.result !=2">
                                <p class="score-num">{{testerInfo.userScore}}
                                    <span>分</span>
                                </p>
                            </div>
                            <div class="zf"  v-if="testerInfo.result !=2">(总分{{testerInfo.paperScore}}分)</div>
                            <div class="reult2" v-if="testerInfo.result ==2">
                                <div class="reult2_tip">答题已结束，感谢您的参加</div>
                                <div class="reult2_pj">请等待老师批卷，批卷完成后将展示成绩</div>
                            </div>
                             <div class="zf">用时：{{convertSecondsToMinutes(testerInfo.doTime,2)}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="答题分析" name="2">
             <div>
    <el-radio-group v-model="radio" @change="getQuestionListCom(radio)">
      <el-radio-button label="1">
        答对（{{testerInfo.rightNum}}）
      </el-radio-button>
       <el-radio-button label="5" v-if="testerInfo.result == 2">
        未批改（{{testerInfo.uncorrectedNum}}）
      </el-radio-button>
      <el-radio-button label="2">
        答错（{{testerInfo.wrongNum}}）
      </el-radio-button>
      <el-radio-button label="3">
        未答（{{testerInfo.unAnswerNum}}）
      </el-radio-button>
      <el-radio-button label="4">
        全部试题（{{testerInfo.questionNum}}）
      </el-radio-button>
    </el-radio-group>
        <div class="watermark">
            <div class="question">
                <div class="question-main-content" v-if="questionList.length">
                    <div class="row" v-for="(item,index) in questionList" :key="item.id">
                        <div class="ques-title flex">
                            <span class="ques-number">{{index+1}}.</span>
                            <span class="ques-type">
                                   {{$util.getTopicType(item.type)}}
                            </span>
                            <span v-html="item.title" style="max-width: 75%;margin:0 10px" :class="item.type == 9 ? 'clozeClass' : ''"></span>
                            <span class="ques-score">（{{item.questionScore}}分）</span>
                        </div>
                          <div class="question-option-list">
                            <ol v-if="item.type != 9 && item.type != 5">
                                <li v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                    <p v-html="sonitem.content"></p>
                                </li>
                            </ol>
                                <div class="refAnswer"  v-if="item.type == 5" style="margin-left:-25px">
                              <div class="detailKeyWorld" v-if="item.rule">
                                  <div class="flex align-cen" style="font-size:16px;color:#999;padding:10px 0">
                                  <p>关键字：</p>
                                      <p v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                      {{sonitem.content}}<span v-if="sonIndex !=item.questionAnswerList.length-1">，</span>
                                  </p>
                                  </div>
                              </div>
                              <div class="detailKeyWorld" v-else style="font-size:16px;color:#999;padding:10px 0">关键字:无</div>
                          </div>
                                <div class="clzoe" v-if="item.type == 9">
                                <div class="clzoeItem" v-for="(sonitem,sonIndex) in item.questionAnswerList" :key="sonIndex">
                                <p class="cloze-op-p" style="margin-left:-25px">
                                    <strong> {{sonIndex + 1}}:</strong>
                                </p>
                                <ol >
                                    <li  v-for="(sonitem1,sonIndex1) in item.questionAnswerList[sonIndex].clozeList" :key="sonIndex1">
                                        <p v-html="sonitem1.content"></p>
                                    </li>
                                </ol>
                                </div>
                            </div>
                          </div>
                        <div class="ques-answers">
                            <div class="test_result flex align-cen">
                                <div class="userAnswer">
                                    <div class="test_result_span_title">考生答案：</div>
                                    <strong :class="item.doRight == 1 ? 'true' : 'false'" v-if="item.isAnswer == '1'">
                                        {{item.answerContent}}
                                        <i :class="item.doRight == 1 ? 'icon-al-check' : 'icon-al-times'" v-if="radio != 5"></i>
                                    </strong>
                                    <span v-else>未作答</span>
                                </div>
                                <div class="rightAnswer" v-if="item.type != 7 && item.type != 9 && item.type != 5">
                                     <div class="test_result_span_title">正确答案：</div>
                                        <div class="dnl flex">
                                            <span v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                        <strong  v-if="sonitem.isRight == 1">
                                        {{Eng[sonIndex]}}
                                    </strong>
                                    </span>
                                    </div>
                                </div>
                                <div v-if="item.type == 5" class="rightAnswer" style="color:#009aff">
                                     <div class="test_result_span_title">参考答案：</div>
                                  <span v-html="item.refAnswer"></span>
                                </div>
                                 <div v-if="item.type == 7" class="rightAnswer">
                                     <div class="test_result_span_title">正确顺序：</div>
                                    <span v-for="(sonitem,sonIndex) in item.sortedIndexes">
                                        <span>
                                        {{Eng[sonitem]}}
                                    </span>
                                    </span>
                                </div>
                                  <div v-if="item.type == 9" class="rightAnswer">
                                     <div class="test_result_span_title">正确答案：</div>
                                    <span v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                                <span style="margin-right:20px">
                                                {{sonIndex + 1}}:
                                                <span v-for="(sonitem1,sonIndex1) in item.questionAnswerList[sonIndex].clozeList" :key="sonIndex1">
                                                    <span v-if="sonitem1.isRight == 1">{{Eng[sonIndex1]}}</span>
                                                </span>
                                                </span>
                                    </span>
                                </div>
                                <div class="score">
                                    <div class="test_result_span_title">分数：</div>
                                    <strong style="color: #36aafd">
                                        {{item.customerScore || '0'}} / {{item.questionScore}}分
                                    </strong>
                                </div>
                            </div>
                        </div>
                          <div class="jx flex align-cen">
                            题目解析：<span v-html="item.analysis || '暂无解析'" style="max-width: 75%;line-height:30px"></span>
                         </div>
                    </div>
                </div>
                <div v-else>
                  <el-empty description="暂无数据"></el-empty>
                </div>
            </div>
        </div>
  </div>
        </el-tab-pane>
        <el-tab-pane label="后台监考" name="3">
            <div class="actions-list" style="padding:0 10px">
                <el-timeline>
                     <el-timeline-item
                    v-for="(activity, index) in resultLogList"
                    :key="index"
                    :type="'success'"
                    :color="'#36aafd'"
                    :size="'large'"
                    placement="top"
                    :timestamp="activity.createTime">
                    <el-card>
                    <h4>{{activity.operate}}</h4>
                    <p> ip:{{activity.ip}}</p>
                </el-card>
                  
                    </el-timeline-item>
                </el-timeline>
            </div>
        </el-tab-pane>
        </el-tabs>
        <div class="info-row flex align-cen">
         <span class="info-col-left flex align-cen"> 
            <i class="icon-al-share"></i>分享
         </span>
         <span class="info-col-right felx align-cen mft">
            <span class="pc-wc-share" @click="sharePaper">
                 <el-tooltip placement="left" class="item" effect="dark" content="查看分享海报" popper-class="silderMenu-tips"  >
                <i class="icon-al-qrcode"></i>
                 </el-tooltip>
            </span>
                
             <span class="pc-wc-share" @click="copyLink">
                <el-tooltip placement="left" class="item" effect="dark" content="复制链接" popper-class="silderMenu-tips"  >
                <i class="icon-al-link"></i>
                  </el-tooltip>
            </span>
         </span>
        </div>
      </el-dialog>
        <el-dialog
  title="监控"
  :visible.sync="centerDialogVisible1"
  width="40%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass"
  v-if="centerDialogVisible1 && isActive == 0"
  >
      <div class="actions-list" style="padding:0 10px">
                <el-timeline>
                     <el-timeline-item
                    v-for="(activity, index) in resultLogList1"
                    :key="index"
                    :type="'success'"
                    :color="'#36aafd'"
                    :size="'large'"
                    placement="top"
                    :timestamp="activity.createTime">
                    <el-card>
                    <h4>{{activity.operate}}</h4>
                    <p> ip:{{activity.ip}}</p>
                </el-card>
                  
                    </el-timeline-item>
                </el-timeline>
            </div>
            </el-dialog>
                    <el-dialog
  title="分享成绩单"
  :visible.sync="centerDialogVisible2"
  width="440px"
  :append-to-body="true"
  center>
    <posterDraw :propImg="propImg" :propText="propText" :propQrcode="link" :dowloadImgName="dowloadImgName" ref="posterEmit"></posterDraw>
</el-dialog>
    </div>
</template>
<script>
import {ResultList,resulttRanscript,monitor,resultMonitorLog,forceSubmit} from '@/api/index/index' // 考试记录分页、查看成绩单、基本信息
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import questionList from "@/components/questionList/index.vue"; //分页组件
import mycomponents from "@/utils/compoments.js"
export default {
    components:{
      paginaTion,
      questionList,
      posterDraw:mycomponents.components.posterDraw
    },
    data() {
        return {
            propData:{},
            propImg:'https://oss.yhkz.com/2024-05-25/%E6%88%91%E7%9A%84%E8%80%83%E8%AF%95%20(2)_20240525134806.jpg',
            propText:'',
            link:'',
            centerDialogVisible2:false,
            dowloadImgName:'成绩单',
            posterImg:'',
            pageInfo:{},
            resultLogList:[],
            Eng:['A','B','C','D','E','F','G','H','I','J'],
            resultQuestionVOList:[],
            questionList:[],
            radio:'1',
            activeName:'1',
            centerDialogVisible:false,
            isSwitch:false,
            isActive:1,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            list:[], 
            multipleSelection:[],
            testerInfo:{},
            resultLogList1:[],
            centerDialogVisible1:false
        }
    },
    created () {
        this.getMonitor()
        this.getResultList(1)
    },
    methods: {
           // 强制交卷
        subqz(data){
             let bfb = Number(data.answerCount)/Number(data.questionCount) * 100
               this.$confirm(`我们建议只强制提交完成率为80%以上的试卷,当前完成率为${bfb}%，是否继续交卷？`, '温馨提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        forceSubmit({id:data.id}).then(res => {
                             this.$message.success('强制交卷成功'); 
                            this.getMonitor()
                             this.getResultList(0)
                            })
                        }).catch(() => {          
                        });
        },
          // 打开监控
        openTimline(data){
            this.centerDialogVisible1 = true
            resultMonitorLog({id:data.id}).then(res => {
              this.resultLogList1 = res.data
            })
        },
        format(percentage){
            return this.testerInfo.userScore || 0 
        },
        format1(){
            return Number(testerInfo.userScore / testerInfo.paperScore) * 100
        },
        // 获取考试监控基本信息
        getMonitor(){
            monitor({id:this.$route.query.id})
            .then(res =>{
               this.pageInfo = res.data
            }) 
        },
        // 打开批卷
        getGradingPaper(data){
            this.$router.push({
            name: "GradingPaper",
            query:{
                id:data.id,
                paperId:this.$route.query.id,
                 redirect:'moniToring',
            }
           })
        },
        copyLink(){
     let _self = this
      this.$copyText(this.link).then(
        function(e) {
            _self.$message.success('复制成功')
        },
        function(e) {
         _self.$message.error('复制失败')
        }
      );
        },
        sharePaper(){
            this.centerDialogVisible2 = true
              this.$nextTick(() => {
                 this.$refs.posterEmit.handleChangeImg(this.propData) 
              })
           
        },
        // 获取成绩单
        getResulttRanscript(data){
            console.log(data)
            this.centerDialogVisible = true
            this.activeName = '1'
             this.radio = '1'
            this.resultQuestionVOList = []
            this.questionList = []
            resulttRanscript({id:data.id}).then(res => {
                this.testerInfo = res.data
                this.resultQuestionVOList = res.data.resultQuestionVOList
                this.propData = data
                this.propText =  `考生：${data.examiner}`
                this.dowloadImgName = data.examiner
                this.link = this.$config.prUrl + '#/myExam/transcriptExam?resultId=' + data.id + '&type=2'
                this.resultQuestionVOList.forEach(k =>{
                if(k.type == 9){
                  k.questionAnswerList.forEach((t,index) =>{
                     let patternString = `{{${index + 1}}}`;
                     k.title = k.title.replace(patternString, '_______')
                  })
                }
                if(k.type == 7){
                  let indexedArray = k.questionAnswerList.map((item, index) => ({ item, index }));  
                   indexedArray.sort((a, b) => a.item.sort - b.item.sort);   
                    k.sortedIndexes = indexedArray.map(item => item.index); 
                }
              })
                this.resultLogList = res.data.resultLogList
                this.getQuestionListCom(1)
            })
        },
        getQuestionListCom(type){
            this.questionList = []
               if(type == 1){
            for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='1' && this.resultQuestionVOList[key].doRight == '1'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 2){
             for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='1' && this.resultQuestionVOList[key].doRight == '0'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 3){
             for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='0'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 4){
            // console.log(this.resultQuestionVOList)
                this.questionList = this.resultQuestionVOList
             }else if(type == 5){
             for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].doRight =='2' && this.resultQuestionVOList[key].isAnswer =='1'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
             }else{
                this.questionList = []
             }
        },
          emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
        this.getResultList(this.isActive, false)
      },
        convertSecondsToMinutes(seconds,type){
            if(seconds >0){
               let hours = Math.floor(seconds / 3600);  
                let minutes = Math.floor((seconds % 3600) / 60);  
                let remainingSeconds = seconds % 60; 
                if(type == 1){
                 return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0');  
                }else{
                    let hoursText = hours > 0 ? hours.toString().padStart(2, '0') + '时' : ''
                     return  hoursText + minutes.toString().padStart(2, '0') + '分' + remainingSeconds.toString().padStart(2, '0') + '秒';  
                }
            }else{
                return 0
            }
        },
          getRowKeyOfTarget(row) {
            return row.id
            },
            // 表格选择
         handleSelectionChange(val) {
        this.multipleSelection = val;
      },
    //   获取考试记录
        getResultList(type,isSwitch){
            this.isActive = type
            this.isSwitch = isSwitch
            if(isSwitch){
                this.currentPage = 1
                this.PageSize = 10
            }
            let params = {
                current: this.currentPage,
                size:this.PageSize,
                state:type,
                id:this.$route.query.id,
                practiceMode:'',
                result:'',
                examiner:'',
                examinerPhone:'',
                startTimeStart:'',
                startTimeEnd:''
            }
            ResultList(params).then(res=>{
                this.list = res.data.records || []
             this.totalCount = res.data.total;
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.print-tab-content{
    margin-top: 20px;
    .tester-info{
        text-align: center;
        .text{
            margin-bottom: 0px;
            font-size: 20px;
            color: #333;
        }
        .lastP{
            font-size: 14px;
            color: #999;
        }
        .sorceRow{
            margin: 20px  0 10px 0;
            .reult2{
                .reult2_pj{
                    font-size:13px;
                    color: #999;
                }
            }
            .exam-record-info{
                flex-grow: 1;
                .score-num{
                   color: #333;
                   font-size: 50px;
                   position: relative;
                   font-weight: bold;
                   span{
                    font-size: 14px;
                    
                   }
                //    .UserNum{
                //     position: absolute;
                //     top: 0; 
                //     right: 0;
                //     .pbot{
                //         font-size: 14px;
                //     }
                //    }
                }
            }
        }
    }
}
.watermark{
    .question{
        margin-top: 50px;
        .question-main-content{
            .row{
                .ques-title{
                    vertical-align: middle;
                    -webkit-margin-before: 0;
                    -webkit-margin-after: 0;
                    word-break: break-word; 
                   .ques-number,.ques-type{
                    color: #36aafd;
                   } 
                   .ques-score{
                    color: #aeaeae;
                   }
                }
                .ques-answers{
                    margin-top: 15px;
                    .test_result{
                        justify-content: space-between;
                        .userAnswer{
                            color: #666;
                            min-width: 100px;
                            .true{
                                color: green;
                                font-size: 16px;
                            }
                            .false{
                                color: red;
                                font-size: 16px;
                            }
                        }
                        .score{
                            min-width: 50px;
                            margin-left: 20px;
                        }
                        .dnl{
                            span{
                               color: #36aafd
                            }
                        }
                    }
                }
                .jx{
                    color: #999;
                        padding-top: 10px;
                }
            }
        }
    }
}
.paperJk{
    position: relative;
    .status-list{
    opacity: 1;
    transform: translateY(0px);
    visibility: visible;
    .status-list-item{
    position: relative;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 180px;
    height: 180px;
    border-radius: 50%;
    cursor: pointer;
    -webkit-transition: all .5s;
    transition: all .5s;
    .circle{
      position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    width: 135px;
    height: 135px;
    border-radius: 25px !important;
    }
    .message{
       position: relative;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 110px;
    height: 110px;
    background-color: #fff;
    -webkit-box-shadow: 0 0 10px 0 rgba(15,51,117,.1);
    box-shadow: 0 0 10px 0 rgba(15,51,117,.1);
    border-radius: 50%;
    margin: 10px auto;
    .num{
        font-size: 18px;
        color: #333;
    }
    .title{
    position: relative;
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #999;
    }
    }
    }
    .status-list-item::after{
    content: "";
    position: absolute;
    bottom: 4px;
    left: 50%;
    width: 34px;
    height: 17px;
    -webkit-transform: translate(-50%,100%);
    transform: translate(-50%,100%);
    background-color: transparent;
    -webkit-clip-path: polygon(0 0,100% 0,50% 100%);
    clip-path: polygon(0 0,100% 0,50% 100%);
    -webkit-transition: all .5s;
    transition: all .5s;
    }
    }
    .active{
    background-color: #eaf6ff;
    border-color: #36aafd;
    .message{
      background-color: #36aafd !important;
      .title,.num{
        color: #fff !important;
      }
    }
    }

        .active::after{
                background-color: #eaf6ff !important;
        }
        .tabbable-custom{
            .rdsdiv{
           height: 20px;
        background: #f7f8fa;
        margin-left: -16px;
        margin-top: 30px;
        width: calc(100% + 32px);
            }
        }
}
::v-deep{
   
    .el-progress__text{
      font-weight: bold;
    font-size: 48px !important;
    color: rgb(231, 58, 48) !important
    }
         .clozeClass{
    p{
        display: inline-block !important;
      }
  }
}
</style>